import { createContext, type FC, type PropsWithChildren, type ReactNode, useContext, useState } from "react";

export type BottomNavigationState = "unset" | "hidden" | "shown";
interface ILayoutContext {
	bottomNavigationState: BottomNavigationState;
	setBottomNavigation: (state: BottomNavigationState) => void;
}

const LayoutContext = createContext<ILayoutContext>({} as ILayoutContext);

export default LayoutContext;

export type LayoutProps = PropsWithChildren<{
	appBarContent?: ReactNode;
	isBottomNavigationBarHidden?: boolean;
}>

// TODO remove completely. Having components from layout context mount on page change can cause ugly bugs.
export const LayoutProvider: FC<LayoutProps> = ({ children }) => {
	const [bottomNavigation, setBottomNavigation] =
		useState<BottomNavigationState>("unset");
	return (
		<LayoutContext.Provider
			value={{
				bottomNavigationState: bottomNavigation,
				setBottomNavigation,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};

export function useLayout(): ILayoutContext {
	return useContext(LayoutContext);
}
